'use strict';
var SeatMapPreferencesSelectionsCollection = Backbone.Collection.extend({
    model: require('../models/seatmap_preferences_selection.model'),
    dataUrl: 'getseatmapselection',
    nTravellers: 0,
    totalSelectableSections: 0,
    perksFromDapi: 0,
    setTotalSelectableSections(totalSelectableSections) {
        this.totalSelectableSections = totalSelectableSections;
    },
    getTotalSelectableSections() {
        return this.totalSelectableSections;
    },
    initialize: function() {

    },
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    setUp: function(options) {
        this.options = Odigeo.Utils.parseOptions(options);
        this.nTravellers = this.options.nTravellers;
        if (this.options.fromSession) {
            this.setPreselectedSeatsFromSession(this.options.bookingId);
        } else {
            this.fillData(options);
        }
    },
    fillData: function(options) {
        const isPostBooking = Odigeo._.get(options, 'isPostBooking', false);
        if (!isPostBooking) {
            this.fetch(this.getDataRequestSettings());
        }
    },
    getDataRequestSettings: function() {
        return {
            type: 'GET',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
        };
    },
    requestSuccessHandler: function(data) {
        this.setPerksFromDapi();
        this.trigger('seatMapSelectionResponseIsOK', data);
    },
    getPerksFromDapi: () => {
        return this.perksFromDapi;
    },
    setPerksFromDapi: () => {
        this.perksFromDapi = this.getInstance().getSelectedSeatsDiscountAmount();
    },
    resetCollection: function() {
        this.remove(this.models);
    },
    getSeat: function(searchPattern) {
        return this.findWhere(searchPattern);
    },
    getFlightSeats: function(section) {
        return this.where({section});
    },
    getNumberOfSectionsWithSeatsSelected: function() {
        if (this.hasSelectedAnySeat()) {
            const sectionsWithSeats = this.reduce((sectionsWithSeats, seat) => {
                if (!sectionsWithSeats[seat.get('section')]) {
                    sectionsWithSeats[seat.get('section')] = 1;
                }
                return sectionsWithSeats;
            }, {});
            return Object.keys(sectionsWithSeats).length;
        } else {
            return 0;
        }
    },
    getNumberOfPassengersWithSeatsSelected: function() {
        if (this.hasSelectedAnySeat()) {
            const passengersWithSeats = this.reduce((passengersWithSeats, seat) => {
                if (!passengersWithSeats[seat.get('numPassenger')]) {
                    passengersWithSeats[seat.get('numPassenger')] = 1;
                }
                return passengersWithSeats;
            }, {});

            return Object.keys(passengersWithSeats).length;
        } else {
            return 0;
        }
    },

    getPriceBreakdownItem: function() {
        var allPrice = this.getSelectedSeatsPrice();
        const allPrimePrice = this.getSelectedSeatsPrimePrice();
        var quantity = this.getSelectedSeatsLength();
        var onePrice = quantity > 0 ? allPrice / quantity : 0;
        return {
            allPrice: allPrice,
            allPrimePrice,
            quantity: quantity,
            onePrice: onePrice,
            type: 'SEATMAP',
            conceptKey: 'seatmap',
            conceptLabel: 'seatmap',
        };
    },

    getSelectedSeatsPrice: function() {
        return this.reduce(function(memo, seat) {
            return memo + seat.get('totalPrice');
        }, 0);
    },
    getSelectedSeatsPrimePrice: function() {
        return this.reduce(function(memo, seat) {
            return memo + seat.get('totalPrimePrice');
        }, 0);
    },
    getSelectedSeatsDiscountAmount: function() {
        return this.reduce(function(memo, seat) {
            return memo + (seat.get('totalPrice') - seat.get('totalPrimePrice'));
        }, 0);
    },
    getTotalPrice: function() {
        return this.getSelectedSeatsPrice();
    },
    getSelectedSeatsLength: function() {
        return this.length;
    },
    hasSelectedAnySeat: function() {
        return this.length > 0;
    },
    getPriceBreakdown: function() {
        return [{
            type: 'SEAT',
            quantity: this.length,
            totalAmount: this.getTotalPrice(),
        }];
    },
    getCurrencyCode: function() {
        return this.hasSelectedAnySeat() ? this.first().get('currencyCode') : null;
    },
    getSeatSelectionFees: function() {
        var totalFees = this.reduce(function(totalFee, seat) {
            return totalFee + (seat.get('totalPrice') - seat.get('providerPrice'));
        }, 0);
        return totalFees > 0 ? totalFees / this.length : 0;
    },
    getSeatSelectionPrimeFees: function() {
        const totalPrimeFees = this.reduce((totalPrimeFee, seat) => {
            return totalPrimeFee + (seat.get('totalPrimePrice') - seat.get('providerPrice'));
        }, 0);
        return totalPrimeFees > 0 ? totalPrimeFees / this.length : 0;
    },
    setPreselectedSeatsFromSession: function(bookingId) {
        if (!this.hasSelectedAnySeat()) {
            const currentSelection = this.getSeatSelectionFromSessionStorage(bookingId);
            this.loadPreselectedSeats(currentSelection);
            this.setPerksFromDapi();
        }
    },
    getSeatSelectionFromSessionStorage(bookingId) {
        const sessionSeatSelectionString = Odigeo.Session.get(`seatSelection_${bookingId}`);
        const sessionSeatSelection = Odigeo.Utils.parseJson(sessionSeatSelectionString) || [];

        return Odigeo._.uniq(sessionSeatSelection, (seat) => {
            const {numPassenger = 1, section = 0} = seat;
            return `${numPassenger}#${section}`;
        });
    },
    addSelection: function(seat) {
        this.addSeatIfNotSelected({
            numPassenger: seat.numPassenger,
            floorSelection: seat.seat.get('floor'),
            rowSelection: seat.seat.get('seatRow'),
            seatMapRow: seat.seat.get('seatMapRow'),
            columnSelection: seat.seat.get('column'),
            providerPrice: seat.seat.get('providerPrice'),
            totalPrice: seat.seat.get('totalPrice'),
            totalPrimePrice: seat.seat.get('totalPrimePrice'),
            currencyCode: seat.seat.get('currencyCode'),
            section: seat.section,
            segment: seat.segment,
        });
    },
    addSeatmapSelection: function(seatSelection) {
        seatSelection.forEach((seat) => {
            this.addSeatIfNotSelected({
                numPassenger: seat.passenger,
                floorSelection: seat.floor,
                rowSelection: seat.row,
                seatMapRow: seat.seatMapRow,
                columnSelection: seat.column,
                providerPrice: seat.seatPrice.amount - seat.seatFee.amount,
                totalPrice: seat.seatPrice.amount,
                currencyCode: seat.seatPrice.currency,
                section: seat.section,
                segment: seat.segment,
            });
        });
    },
    isNotSelected(seat) {
        return Odigeo._.isUndefined(this.getSeat({
            numPassenger: seat.numPassenger,
            section: seat.section,
        }));
    },
    addSeatIfNotSelected(seat) {
        if (this.isNotSelected(seat)) {
            this.add(seat);
        }
    },
    loadPreselectedSeats: function(selectedSeatMap) {
        if (selectedSeatMap.length) {
            this.reset();
        }

        Odigeo._.each(selectedSeatMap, function(seat) {
            this.addSeatIfNotSelected(seat);
        }, this);
    },
    removeSelection: function(model) {
        this.remove(model);
    },
    getNumSelectableSections(seatMapInfo) {
        return Odigeo._.size(Odigeo._.filter(seatMapInfo, (segment) => segment.isSelectable));
    },
});
var instance;

module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new SeatMapPreferencesSelectionsCollection();
    }
    return instance;
};
